module.exports = "./img/desktop_logo.4c7ff27.png";